import {getUser} from '@/utils/auth';
import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper";
import {isEmpty} from "@/utils/fileHelper";

export function isResponsable() {
  let isResponsable = false;
  let user = getUser();
  // console.log(user)
  for (let equipe of user.equipes) {
    if (equipe.pivot.role === 'responsable') { isResponsable = true }
  }

  return isResponsable || hasRule(rules.IS_RESPONSABLE);
}

export function getUserTraitementIds() {
  let user = getUser();
  let traitementIds = !isEmpty(user.profil_active) && !isEmpty(user.profil_active[0]) ? user.profil_active[0].traitements.map(traitement => parseInt(traitement.id,10)) : [];

  return traitementIds;
}

export function hasTraitement(libelleTechnique) {
  let user = getUser()
  let userTraitement = !isEmpty(user.profil_active) && !isEmpty(user.profil_active[0]) ? user.profil_active[0].traitements.map(traitement => traitement.libelle_technique) : [];
  return userTraitement.indexOf(libelleTechnique) > -1
}
